
(function(){
  let count=0;

  window.pureSelectImage=function(src,el){
    const main=document.getElementById('PureMainImage');
    if(main) main.src=src;
    document.querySelectorAll('.pure-thumb').forEach(x=>x.classList.remove('active'));
    if(el) el.classList.add('active');
  };

  window.pureChangeQty=function(n){
    const input=document.getElementById('PureQty');
    if(!input)return;
    input.value=Math.max(1,(parseInt(input.value,10)||1)+n);
  };

  document.addEventListener('DOMContentLoaded',function(){
    const variantSelect=document.getElementById('PureVariantSelect');
    const price=document.getElementById('PurePrice');
    const addPrice=document.getElementById('PureAddPrice');
    const stock=document.getElementById('PureStock');
    const addButton=document.querySelector('#PureProductForm .pure-add');

    function updateVariant(){
      if(!variantSelect)return;
      const option=variantSelect.options[variantSelect.selectedIndex];
      const available=option.dataset.available === 'true';
      if(price) price.textContent=option.dataset.price || '';
      if(addPrice) addPrice.textContent=option.dataset.price || '';
      if(stock) stock.innerHTML=available
        ? '<span class="pure-dot"></span>In Stock'
        : 'Out of Stock';
      if(addButton) addButton.disabled=!available;
    }

    if(variantSelect){
      variantSelect.addEventListener('change',updateVariant);
      updateVariant();
    }

    // Update the cart badge from Shopify's current cart on page load.
    fetch('/cart.js')
      .then(r=>r.json())
      .then(cart=>{
        count=cart.item_count || 0;
        document.querySelectorAll('.pure-count').forEach(b=>b.textContent=count);
      })
      .catch(()=>{});

    // AJAX add-to-cart where supported, then update the badge and redirect
    // to the cart so checkout behavior remains Shopify-native.
    const form=document.getElementById('PureProductForm');
    if(form){
      form.addEventListener('submit',function(e){
        const submitter=e.submitter;
        if(submitter && submitter.name === 'add' && submitter.value === 'buy_now'){
          return;
        }
        e.preventDefault();

        const formData=new FormData(form);
        fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:formData})
          .then(r=>r.json().then(data=>({ok:r.ok,data})))
          .then(result=>{
            if(!result.ok) throw new Error(result.data.description || 'Unable to add to cart');
            return fetch('/cart.js');
          })
          .then(r=>r.json())
          .then(cart=>{
            count=cart.item_count || 0;
            document.querySelectorAll('.pure-count').forEach(b=>b.textContent=count);
            window.location.href='/cart';
          })
          .catch(()=>{ form.submit(); });
      });
    }
  });
})();
